import { render, staticRenderFns } from "./Courseware.vue?vue&type=template&id=3c5c50ab&scoped=true"
import script from "./Courseware.vue?vue&type=script&lang=js"
export * from "./Courseware.vue?vue&type=script&lang=js"
import style0 from "./Courseware.vue?vue&type=style&index=0&id=3c5c50ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5c50ab",
  null
  
)

export default component.exports